import React from "react";

export default function Footer() {
  return (
    <footer id="Footer" className="bg-[#6BB2A0] text-white py-8 text-center">
      <p>&copy; 2025 ORTHOC Healthcare. All Rights Reserved.</p>
    </footer>
  );
}
